export const businessModel = {
label: 'BUSINESS MODEL',
title: 'Products First. Relationships Matter.',
subtitle: 'One More Global Inc. operates through a direct sales model centered on physical consumer products and supported by independent distributors.',

core_overview_p1: 'One More Global Inc. markets and distributes wellness and personal care products through a direct sales model. Independent distributors support product awareness, customer relationships, and market development in accordance with company policies and applicable requirements.',
core_overview_p2: 'The business model is built around physical consumer products, product distribution, customer service, and long-term market development.',

components_badge: 'Business Model Components',
components_title: 'How Our Business Operates',

component_1_title: 'Physical Products',
component_1_desc: 'The business is centered on the marketing and distribution of physical wellness and personal care products.',

component_2_title: 'Independent Distributors',
component_2_desc: 'Independent distributors support product awareness, customer relationships, and market development.',

component_3_title: 'Customer Relationships',
component_3_desc: 'Long-term customer relationships are supported through product information, service, and responsible communication.',

component_4_title: 'Responsible Growth',
component_4_desc: 'Market development is approached through disciplined execution, operational readiness, and long-term business relationships.',
};
